import { useRouter } from '@application/utils';
import type { BreedComparatorGetBreedsQuery } from '@gql/graphql';
import { DogBreedImgType } from '@gql/graphql';
import { PLACEHOLDER_IMAGE_DOG } from '@presentation/constants';
import type { BreedCategoriesData } from '@presentation/pages';

export const useFormatCategories = (breeds: BreedComparatorGetBreedsQuery['findManyDogBreed']) => {
  const { routeLocationDescriptor, language } = useRouter();

  const formatCategories = (): BreedCategoriesData => {
    if (!breeds || breeds.length === 0) {
      return { breeders: [], litters: [] };
    }

    return {
      breeders: breeds.map((breed) => ({
        name: breed.translations.find((tr) => tr.language === language)?.name as string,
        link: `${routeLocationDescriptor('breederList').pathname}${breed.name}`,
        image:
          breed.imgs.find((img) => img.type === DogBreedImgType.MAIN)?.small ??
          PLACEHOLDER_IMAGE_DOG,
      })),
      litters: breeds.map((breed) => ({
        name: breed.translations.find((tr) => tr.language === language)?.name as string,
        link: `${routeLocationDescriptor('litterList').pathname}${breed.name}`,
        image:
          breed.imgs.find((img) => img.type === DogBreedImgType.MAIN)?.small ??
          PLACEHOLDER_IMAGE_DOG,
      })),
    };
  };

  return { formattedCategories: formatCategories() };
};
